import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-cyan-600 to-blue-600 text-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">PURECODE Ltd</h3>
            <p className="text-teal-100 text-sm mb-4">
              Premier IT consultancy specializing in AI-driven solutions for banking, fintech, and betting industries.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/purecodeltd"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                aria-label="Visit PURECODE on LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Software Development
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  AI & Machine Learning
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Cloud Solutions
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Cybersecurity
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-teal-100 hover:text-white transition-colors cursor-pointer">
                  Data Analytics
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <address className="not-italic text-sm text-teal-100 space-y-2">
              <p className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>The Genesis Centre, Birchwood<br />Warrington, England<br />WA3 7BH</span>
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:01925357468" className="hover:text-white transition-colors cursor-pointer">
                  01925 357 468
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:hello@purecode.uk" className="hover:text-white transition-colors cursor-pointer">
                  hello@purecode.uk
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-teal-400/30 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-teal-100">
            <p>&copy; {currentYear} PURECODE Ltd. All rights reserved.</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <Link to="/privacy" className="hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer nofollow"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
